import React, { useCallback, useContext, useEffect, useState,useMemo,useRef } from "react";
import EmptyVideosIconSVG from "assets/svg/empty-videos-icon";
import ViewButtonModal from "../milestones/media-button/watch";
import { FaEllipsisH, FaPlus } from "react-icons/fa";
import toast from "react-hot-toast";
import _ from "lodash";
import Loader from "components/loader/loader";
import { useDialogHook } from "utils/customhooks";
import { IoClose } from "react-icons/io5";
import Button from "components/button/button";
import LoadingIndicator from "assets/svg/loading-indicator";

import UpgradePremium from "components/subscription/upgrade-premium";
import LockOutlineIcon from "assets/svg/upgrade/lock-outline-icon";
import { SubscriptionContext } from "context/subscription";

import EmptyData from "./empty-data";
import AddVideoModal from "./add-video-modal";
import EditVideoModal from "./edit-video-modal";

import { AdultContentIndicator } from "./photos-videos";
import PopInfo from "components/info-popup/pop-info";
import Popup from "reactjs-popup";
import ReportPhotoVideo from "./report";
import { PiWarningOctagonLight } from "react-icons/pi";
import PlayIconCircleWhiteSVG from "assets/svg/play-icon-circle-white";
import { LogoWhite } from "constants/images";
import { GoStarFill } from "react-icons/go";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { LangContext } from "context/language";
import { BsPencilSquare } from "react-icons/bs";


const noop = () => {};

export default function ManageVideos({ userData = {}, profile = {}, onVideosChanged = () => {} }) {
  const { http } = global.services;
  const { t } = useTranslation();
  const { isSubscribed } = useContext(SubscriptionContext);

  const isOwner = profile?.id === userData?.profile.id;

  const { profileId } = useParams();
  const fetchMilestonesId = useRef(0);
  const {TypeOject} = useContext(LangContext);
  // ===================== state ============================
  const optionRef = React.useRef();
  const [showMoreOption, setShowMoreOption] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  // const [list, setList] = useState([]);
  const [groupedList, setGroupedList] = useState([]);
  const list = useMemo(() => {
    return groupedList[profile.id];
  }, [groupedList, profile.id]);

  const setList = useCallback((value) => {
    setGroupedList(s => ({ ...s, [profile.id] : value}))
  }, [profile.id]);

  const [page, setPage] = useState(1);
  const [loadmore, setLoadmore] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState({});
  const [hasMore, setHasMore] = useState(false);
  const [showDeleteBtn, setShowDeleteBtn] = useState(false);
  const viewVideo = useDialogHook(ViewButtonModal);
  const addVideo = useDialogHook(AddVideoModal);
  const editVideo = useDialogHook(EditVideoModal);
  const emptyMessage = isOwner
    ? t('noVideosStart')
    : t('noVideos');
  let checkReported = null;
  const modalReport = useDialogHook(ReportPhotoVideo);
  const { user } = profile;
  const buttonProps = {
    edit: {
      btnName: "Edit",
      btnClass: "relative py-3.6 px-5.5 bg-modalGray hover:bg-gray",
      btnTextClass:
        "text-sm text-lightBlack font-semibold flex items-center space-x-1.6",
    },
  };
  if (!_.isEmpty(user?.reports))
    checkReported = user?.reports.find(
      (report) => report.user_id === userData?.user?.id
    );
  // ===================== functions =========================
  const onUploadImagesVideos = async (files) => {
    let payload = new FormData();
    payload.append("user_id", userData?.user?.id);
    payload.append("user_profile_id", userData?.profile?.id);
    payload.append("type", "video");

    if (!_.isEmpty(files)) {
      //loop
      _.forEach(files, function (obj, index) {
        payload.append(`media[${index}]`, obj);
      });
      //end loop -- start upload
      try {
        setUploadLoading(true);
        const { data } = await http.post(`public/user-galleries`, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (data) {
          toast.success(data.message);
          getVideos("refetch");
          setUploadLoading(false);
        }
      } catch (error) {
        toast.error(
          error?.data?.message || "It appears that something went wrong"
        );
        setUploadLoading(false);
      }
    }
  };

  const getVideos = useCallback(
    async (e) => {
      if(!profile.id) return;
      if (e !== "refetch" && e !== "loadmore") {
        setLoading(true);
      }
      try {
        let currentPage = page;
        if (e === "loadmore") {
          setLoadmore(true);
          currentPage = page + 1;
        }
        const requestId = ++fetchMilestonesId.current;
        const result = await http.get(`public/user-galleries`, {
          user_profile_id: profile?.id || profileId,
          type: "video",
          limit: 5,
          page: currentPage,
        });
        if (requestId !== fetchMilestonesId.current) {
          console.log("Ignoring outdated response");
          return;
        }
        const res = result.data;
        if (!_.isEmpty(res.data)) {
          let newData = res.data;
          if (e === "loadmore") {
            //checking if empty
            if (_.isEmpty(list)) {
              setList(newData);
            } else {
              //if not empty
              let payload = _.clone(list || []);
              if (!_.isEmpty(newData)) {
                // dedupe: some APIs re-return pinned/starred items (e.g. the
                // showreel) on every page, so guard against pushing the same
                // record in twice, which was causing it to render twice.
                const existingIds = new Set(payload.map((p) => p.id));
                newData.forEach((n) => {
                  if (!existingIds.has(n.id)) {
                    payload.push(n);
                    existingIds.add(n.id);
                  }
                });
                //end loop
                setList(payload);
                setPage(currentPage);
              }
            }
          } else {
            setList(res.data);
          }

          setHasMore(res.current_page !== res.last_page);
          setLoading(false);
          setLoadmore(false);
        } else {
          setHasMore(false);
          setLoading(false);
          setLoadmore(false);
          if (e === "loadmore") {
            return toast.success("All Videos are already loaded.");
          }
        }
      } catch (error) {
        toast.error(
          error?.data?.message || "It appears that something went wrong"
        );
        setLoading(false);
        setLoadmore(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [list,page, profile.id]
  );

  const globalButtonClick = (e) => {
    onUploadImagesVideos(e);
  };

  const handleWatch = (url,orientation = "Landscape") => {
    viewVideo({ url, orientation }, (result) => {
      console.log("result =>", result);
    });
  };

  const onDeleteImageVideos = async (record) => {
    try {
      setLoadingDelete((prev) => ({ ...prev, [`video_${record.id}`]: true }));
      const result = await http.delete(`public/user-galleries/${record.id}`);
      const res = result.data;
      if (res) {
        toast.success(res.message);
        //remove image
        let payloadImages = _.clone(list);
        _.remove(payloadImages, function (obj) {
          return obj.id === record.id;
        });
        setList(payloadImages);
        //end remove
        // keep the profile's front-page showreel in sync if it was removed
        onVideosChanged(payloadImages);
      }
    } catch (error) {
      toast.error(
        error?.data?.message || "It appears that something went wrong"
      );
      setLoadingDelete((prev) => ({
        ...prev,
        [`video_${record.id}`]: false,
      }));
    }
  };

  const onAdd = () => {
    addVideo(
      {
        userData,
        profile,
      },
      (callback) => {
        if (callback) {
          getVideos();
        }
      }
    );
  };

  const reportPhotoVideo = (media = {}, type = "photo") => {
    modalReport({ userData, media, type }, (callback) => {
      console.log(callback);
      if (callback && callback.success) {
        if (type === "photo") {
        }
      }
    });
  };

  //============================ useEffects ==========================
  useEffect(() => {
    if (profile) {
      getVideos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);

  const footer = (
    <div className="w-full grid justify-center">
      {_.isEmpty(list) && !loading && isOwner ? (
        <button
          onClick={onAdd}
          className={`relative py-4 px-6 rounded-md bg-modalGray ${
            uploadLoading ? "opacity-50" : "hover:bg-gray"
          }`}
        >
          <div className="flex items-center space-x-2.5">
            {!loading && <FaPlus className=" w-3 h-3" />}
            <span>
              {loading ? `${t('uploading')} ....` : t("addFile", { file: t("videos") })}
            </span>
            {loading && <LoadingIndicator className="w-5 h-5" />}
          </div>
        </button>
      ) : (
        <>
          {!loading && hasMore && (
            <Button
              onClick={() => getVideos("loadmore")}
              buttonName={t("loadMore")}
              buttonTextClass={`text-sm text-primary font-semibold ${
                loadmore ? "flex items-center space-x-2" : "load-more-text"
              }`}
              buttonRadius="6px"
              buttonClass={`relative py-4 px-6 border-2 border-primary rounded-md ${
                loadmore ? "" : "load-more-hover"
              }`}
              disabled={loadmore}
              loadingIcon={
                loadmore ? (
                  <LoadingIndicator className="text-primary w-4 h-4" />
                ) : null
              }
            />
          )}
        </>
      )}
    </div>
  );

  const editFile = (obj)=>{
    editVideo({data:obj,profile},(callback)=>{
      const data = callback?.data;
      if(!data) return;
      // Apply the edit to the edited item, and — because only one video can be
      // the showreel / the front-page showreel at a time — clear those flags on
      // every other video when this one now owns them. This updates the Videos
      // "My Showreel" tile immediately (reel is derived from is_showreels).
      const updateList = (list || []).map((item)=>{
        if(item.id === data.id){
          return { ...item, ...data };
        }
        const patch = {};
        if(data.is_showreels) patch.is_showreels = false;
        if(data.is_front_page_showreel) patch.is_front_page_showreel = false;
        return Object.keys(patch).length ? { ...item, ...patch } : item;
      });
      setList(updateList);
      setShowDeleteBtn(false);
      // Let the profile page refresh the front-page showreel (shown above the
      // milestones feed) without a page reload.
      onVideosChanged(updateList);
    })
  }

  return (
    <div className="w-full max-w-full overflow-hidden bg-white rounded-md px-5 2md:pl-29 2md:pr-24.5 py-10 md:pb-14 md:pt-8">
      <div className="w-full min-w-0 grid gap-y-8">
        {/* ===================== title ========================== */}
        <div className="flex justify-between items-center gap-3">
          <div className="w-full flex flex-row items-center space-x-2">
            {isOwner && !isSubscribed && <LockOutlineIcon />}
            <h1 className="text-2xl font-semibold text-lightBlack">
              {t("videos")}
            </h1>
            {/* pop info */}
            <PopInfo containerClass="relative" type="videos" />
            {isOwner && isSubscribed && (
              <div>
                <Button
                buttonName={t('addVideos')}
                buttonTextClass="text-xs 2sm:text-sm text-white font-semibold flex items-center justify-center"
                buttonRadius="6px"
                iconPosition="left"
                icon={<FaPlus className="mr-2" />}
                buttonClass="relative ml-4 py-3.5 2sm:py-5 px-5 2sm:px-10 bg-primary hover:bg-darkPrimary w-full 2sm:w-fit"
                onClick={onAdd}
              />
              </div>
            )}
          </div>
          {isOwner && isSubscribed && (
            <>
              {showDeleteBtn ? (
                <Button
                  buttonName="Cancel"
                  buttonTextClass={buttonProps.edit.btnTextClass}
                  buttonClass={buttonProps.edit.btnClass}
                  onClick={() => {
                    setShowDeleteBtn((prev) => !prev);
                  }}
                />
              ) : (
                <Popup
                  ref={optionRef}
                  position="bottom right"
                  open={showMoreOption}
                  onClose={() => setShowMoreOption(false)}
                  arrow={false}
                  contentStyle={{
                    marginTop: 10,
                    marginLeft: 5,
                    zIndex: 9999,
                  }}
                  trigger={
                    <button
                      className="bg-thBg w-10 h-10 rounded-md"
                      onClick={() => setShowMoreOption((open) => !open)}
                    >
                      <FaEllipsisH className="m-auto text-1xs 2sm:text-base" />
                    </button>
                  }
                >
                  <div className="flex flex-col shadow-lg rounded-md bg-white">
                    <ul>
                      <li className="hover:bg-gray hover:rounded-t-md">
                        <button
                          className="flex flex-row items-center text-lg px-6 py-2"
                          onClick={() => {
                            setShowDeleteBtn(true);
                            optionRef.current.close();
                          }}
                        >
                          {t("editFile", { file: t("videos") })}
                        </button>
                      </li>
                      <li className="hover:bg-gray hover:rounded-b-md">
                        <button
                          className="flex flex-row items-center text-lg px-6 py-2"
                          onClick={() => {
                            onAdd();
                            optionRef.current.close();
                          }}
                        >
                          {t("addFile", { file: t("videos") })}
                        </button>
                      </li>
                    </ul>
                  </div>
                </Popup>
              )}
            </>
          )}
        </div>
        {/* =================== Body ============================= */}
        {!isOwner ? (
          <>
            <div className="w-full">
              {loading ? (
                <Loader message={<EmptyVideosIconSVG />} />
              ) : (
                <>
                  {_.isEmpty(list) ? (
                    <EmptyData
                      icon={TypeOject.emptIcon["video"]}
                      emptyMessage={emptyMessage}
                    />
                  ) : (
                    <ListVideos
                      handleAdd={noop}
                      handleWatch={(e,orient) => handleWatch(e,orient)}
                      loading={uploadLoading}
                      loadingDelete={{}}
                      onCallBack={(e) => globalButtonClick(e)}
                      list={list}
                      message={t("addFile", { file: t("videos") })}
                      handleDelete={
                        isOwner ? (e) => onDeleteImageVideos(e) : noop
                      }
                      readOnly={true}
                      reportPhotoVideo={reportPhotoVideo}
                      checkReported={checkReported}
                      showDeleteBtn={showDeleteBtn}
                    />
                  )}
                </>
              )}
            </div>

            {footer}
          </>
        ) : isSubscribed ? (
          <>
            <div className="w-full">
              {loading ? (
                <Loader message={<EmptyVideosIconSVG />} />
              ) : (
                <>
                  {_.isEmpty(list) ? (
                    <EmptyData
                      icon={TypeOject.emptIcon["video"]}
                      emptyMessage={emptyMessage}
                    />
                  ) : (
                    <ListVideos
                      handleAdd={onAdd}
                      handleWatch={(e,orient) => handleWatch(e,orient)}
                      loading={uploadLoading}
                      loadingDelete={loadingDelete}
                      onCallBack={(e) => globalButtonClick(e)}
                      list={list}
                      message={t("addFile", { file: t("videos") })}
                      handleDelete={(e) => onDeleteImageVideos(e)}
                      isOwner={isOwner}
                      showDeleteBtn={showDeleteBtn}
                      editFile={editFile}
                    />
                  )}
                </>
              )}
            </div>

            {/* =================== Footer ============================= */}
            {footer}
          </>
        ) : (
          <UpgradePremium styleProp="list" customHeadline="Bio Videos - Upgrade to Unlock" customText="Upgrade so you can add videos and show reels in your bio"/>
        )}
      </div>
    </div>
  );
}

function ListVideos({
  list = [],
  type = "",
  message = "",
  onCallBack = noop,
  loading = false,
  loadingDelete = {},
  handleAdd = noop,
  handleWatch = noop,
  handleDelete = noop,
  readOnly = false,
  isOwner = false,
  reportPhotoVideo = noop,
  checkReported,
  showDeleteBtn = false,
  editFile=()=>{}
}) {
  // Only one showreel is ever pinned (editFile already unsets `is_showreels`
  // on any other record when a new one is set). Take the first defensively.
  const reel = useMemo(() => {
    const reels = (list || []).filter((item) => item.is_showreels);
    return reels.length > 0 ? reels[0] : null;
  }, [list]);

  const regulars = useMemo(() => {
    const regularItems = (list || []).filter(
      (item) => !item.is_showreels || item.id !== reel?.id
    );
    return _.uniqBy(regularItems, "id");
  }, [list, reel]);

  // Shared props for every tile.
  const mediaProps = (obj, index) => ({
    index,
    obj,
    readOnly,
    loadingDelete: readOnly ? noop : loadingDelete,
    handleWatch: (e, orient) => handleWatch(e, orient),
    handleDelete: readOnly ? noop : (e) => handleDelete(e),
    reportPhotoVideo,
    checkReported,
    showDeleteBtn,
    editFile,
  });

  // Uniform 16:9 grid, 3 across. The showreel (if present) spans the full width
  // of that 3-across row and keeps the same 16:9 proportions; every other video
  // sits 3-across below it. Portrait / odd-ratio videos letterbox (black bars)
  // inside the 16:9 box. Each tile carries a 2px dark-grey border (see Media).
  return (
    <div className="w-full grid grid-cols-1 2sm:grid-cols-2 1md:grid-cols-3 gap-4">
      {reel && (
        <div className="col-span-full">
          <p className="flex gap-2 items-center font-bold text-lg mb-2">
            <span className="text-primary">
              <GoStarFill />
            </span>
            My Showreel
          </p>
          <Media {...mediaProps(reel, 0)} />
        </div>
      )}

      {regulars.map((obj, index) => (
        <Media key={`video-${obj.id}`} {...mediaProps(obj, index)} />
      ))}
    </div>
  );
}

function Media({
  index,
  obj,
  readOnly = false,
  loadingDelete = {},
  handleWatch,
  handleDelete,
  reportPhotoVideo,
  checkReported,
  showDeleteBtn = false,
  editFile=()=>{},
}) {
  const [showMoreOption, setShowMoreOption] = useState();

  return (
    <div
      className={`relative cursor-pointer rounded-md overflow-hidden w-full aspect-[16/9] bg-black border-2 border-[#555555] flex items-center justify-center${
        readOnly ? " photo-video-item-wrapper" : ""
      }`}
      key={`video-${index}`}
    >
      {readOnly ? (
        <>
          <div
            className={`flex justify-center items-center photo-video-hover-menu${
              showMoreOption ? " active" : ""
            }`}
            onClick={() => setShowMoreOption((open) => !open)}
          >
            <FaEllipsisH className="p-0 m-0" />
          </div>

          <Popup
            position="bottom right"
            open={showMoreOption}
            onClose={() => setShowMoreOption(false)}
            arrow={false}
            contentStyle={{ marginTop: 10, marginLeft: 5 }}
            trigger={
              <div className="flex justify-center items-center photo-video-hover-menu-hidden"></div>
            }
          >
            <div className="flex flex-col shadow-lg rounded-md bg-white">
              <ul className="w-full">
                <li className="hover:bg-gray hover:rounded-md">
                  <button
                    onClick={() => {
                      reportPhotoVideo(obj, "video");
                      setShowMoreOption(false);
                    }}
                    className={`flex flex-row items-center text-lg px-4 py-2 gap-2 ${
                      checkReported && "bg-gray cursor-not-allowed"
                    }`}
                  >
                    <PiWarningOctagonLight className="text-lg" />
                    {`${checkReported ? "Reported" : "Report Video"}`}
                  </button>
                </li>
                {/* {isYourProfile && (
                    <li className="hover:bg-gray hover:rounded-md">
                      <button
                        onClick={() => {
                          // history.push("/settings", {
                          //   profile,
                          // });
                        }}
                        className="flex flex-row items-center text-lg px-4 py-2 gap-2">
                        <FiSettings className="text-lg" />
                        Settings
                      </button>
                    </li>
                  )} */}
              </ul>
            </div>
          </Popup>
        </>
      ) : (
        <>
          {showDeleteBtn && (
            <div className="absolute z-40 right-2 top-2">
                <div className="flex gap-2">
                  <button
                    className={`h-8 w-8 bg-black opacity-90 rounded-full`}
                    onClick={() => editFile(obj)}
                    disabled={loadingDelete[`video_${obj.id}`]}
                  >
                    {loadingDelete[`video_${obj.id}`] ? (
                      <LoadingIndicator className="h-4 w-4 text-white m-auto" />
                    ) : (
                      <BsPencilSquare className="text-white text-lg m-auto" />
                    )}
                  </button>
                  <button
                    className={`h-8 w-8 bg-black opacity-90 rounded-full`}
                    onClick={() => handleDelete(obj)}
                    disabled={loadingDelete[`video_${obj.id}`]}
                  >
                    {loadingDelete[`video_${obj.id}`] ? (
                      <LoadingIndicator className="h-4 w-4 text-white m-auto" />
                    ) : (
                      <IoClose className="text-white text-lg m-auto" />
                    )}
                  </button>
                </div>
            </div>
          )}
        </>
      )}
      <div className="absolute inset-0 overflow-hidden">
        {obj.media?.webp_url || obj.media?.url ? (
          <img
            onClick={() => handleWatch(obj.link)}
            src={obj.media?.webp_url || obj.media?.url}
            alt={obj.id}
            className="absolute inset-0 w-full h-full object-contain object-center"
          />
        ) : (
          <img
            onClick={() => handleWatch(obj.link)}
            src={LogoWhite}
            alt={obj.id}
            className="absolute inset-0 m-auto w-[30%] object-contain object-center"
          />
        )}
      </div>
      <div
        className="absolute inset-0 m-auto w-14 h-14 flex items-center justify-center"
        onClick={() => handleWatch(obj.link, obj?.orientation)}
      >
        <PlayIconCircleWhiteSVG className="w-14 h-14" />
      </div>

      {!!obj.is_adult_content && (
        <AdultContentIndicator className="absolute top-0 left-0" />
      )}
    </div>
  );
}
